import Service from "../../Services";

const Search = {
    namespaced: true,
    state: {
        keyword: "",
        result: {
            program: null,
            article: null
        }
    },
    mutations: {
        setKeyword(state, data) {
            state.keyword = data;
        },
        resetKeyword(state) {
            state.keyword = "";
        },
        setProgramResult(state, data) {
            state.result.program = data;
        },
        setArticleResult(state, data) {
            state.result.article = data;
        },
        clearResult(state) {
            state.result.program = null;
            state.result.article = null;
        }
    },
    actions: {
        onSetKeyword({ commit }, data) {
            commit('setKeyword', data);
        },
        onResetKeyword({ commit }) {
            commit('resetKeyword');
        },
        onClearResult({ commit }) {
            commit('clearResult');
        },
        onSearch({ commit }, data) {
            switch (data.mode) {
                case 0:
                    // program
                    return Service.SearchAPI.searchPrograms(data).then(res => {
                        if (res) {
                            commit('setProgramResult', res);
                        }
                    });

                case 1:
                    // article
                    return Service.SearchAPI.searchArticles(data).then(res => {
                        if (res) {
                            commit('setArticleResult', res);
                        }
                    });
            }
        }
    }
};
export default Search
